module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "pesquisa"
  }, [_c('h2', [_vm._v("procurar e marcar")]), _vm._v(" "), _c('label', [_c('gmap-autocomplete', {
    on: {
      "place_changed": _vm.setPlace
    }
  }), _vm._v(" "), _c('button', {
    on: {
      "click": _vm.addMarker
    }
  }, [_vm._v("Adc")])], 1), _vm._v(" "), _c('br')]), _vm._v(" "), _c('br'), _vm._v(" "), _c('gmap-map', {
    staticStyle: {
      "width": "100%",
      "height": "78%",
      "position": "absolute"
    },
    attrs: {
      "center": _vm.center,
      "zoom": 15
    }
  }, _vm._l((_vm.markers), function(m, index) {
    return _c('gmap-marker', {
      key: index,
      attrs: {
        "position": m.position
      },
      on: {
        "click": function($event) {
          _vm.center = m.position
        }
      }
    })
  }), 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6ee517f6","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/app/website/mapa/components/GoogleMap.vue
// module id = 1758
// module chunks = 17